import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const careerSliderItems = `${REACT_APP_API_PREFIX}/${service}/careerSliderItems`;

export function getCareerSliderItems(filters) {
  const url = `${careerSliderItems}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getCareerSliderItemById(id) {
  const url = `${careerSliderItems}/${id}`;
  return {
    method: GET,
    url,
  };
}

export function updateCareerSliderItem(id, body) {
  const url = `${careerSliderItems}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteCareerSliderItem(id) {
  const url = `${careerSliderItems}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createCareerSliderItem(body) {
  const url = `${careerSliderItems}`;
  return {
    method: POST,
    url,
    body,
  };
}
